import styles from './AISuggestionReview.module.css';

export interface AISuggestionReviewProps {
  fieldLabel: string;
  currentValue: string | null;
  suggestedValue: string | null;
  source?: string;
  accepted: boolean;
  onToggleAccept: (accepted: boolean) => void;
  className?: string;
}

/**
 * AISuggestionReview - Show Current → Suggested with accept/reject checkbox
 *
 * Used in STATE 4 (AI Suggestions) of the 5-state workflow
 */
export function AISuggestionReview({
  fieldLabel,
  currentValue,
  suggestedValue,
  source,
  accepted,
  onToggleAccept,
  className = ''
}: AISuggestionReviewProps) {
  const hasChange = suggestedValue !== null && suggestedValue !== currentValue;
  const displayCurrent = currentValue || '[empty]';
  const displaySuggested = suggestedValue || '[no change]';

  return (
    <div className={`${styles.suggestion} ${className}`}>
      <div className={styles.header}>
        <span className={styles.fieldLabel}>{fieldLabel}:</span>
        {hasChange && (
          <label className={styles.acceptLabel}>
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => onToggleAccept(e.target.checked)}
              className={styles.checkbox}
            />
            <span>Accept</span>
          </label>
        )}
      </div>

      <div className={styles.comparison}>
        <div className={styles.currentValue}>
          <span className={styles.valueLabel}>Current:</span>
          <span className={styles.value}>{displayCurrent}</span>
        </div>

        <div className={styles.arrow}>→</div>

        <div className={hasChange ? styles.suggestedValue : styles.noChange}>
          <span className={styles.valueLabel}>Suggested:</span>
          <span className={styles.value}>{displaySuggested}</span>
        </div>
      </div>

      {source && hasChange && (
        <div className={styles.source}>
          <span className={styles.sourceIcon}>🔗</span>
          Source: {source}
        </div>
      )}
    </div>
  );
}

export default AISuggestionReview;
